<template>
        <!-- Masthead-->
        <header class="masthead bg-primary text-white text-center">
          <v-idle style="display:none !important;" @idle="onidle"
  @remind="onremind" :duration="10"/>
            <div class="container d-flex align-items-center flex-column">
                <!-- Masthead Avatar Image-->
                <img class="masthead-avatar mb-1" src="../assets/viber_image_2022-01-14_14-47-18-290.png" alt="..." />
                <!-- Masthead Heading-->
                <img class="smart-loa" src="../assets/smarLOAlogo.png" alt="..." />
                
                <button @click="goToLogin()" class="btn btn-home" type="button">Please Click To Proceed</button>
                <!-- Masthead Subheading-->
                <p class="masthead-subheading font-weight-light mb-0">www.philcare.com.ph</p>
                 <img class="masthead-avatar mb-5 icons-img" src="../assets/phil-icons.png" alt="..." />
                 <p class="masthead-subheading font-weight-light mb-0">/philcareph</p>
            </div>
        </header>
</template>

<script>


export default {
  name: 'PhilHome',
  props: {
    msg: String
    
  } ,methods:{
   goToLogin(){
   this.$router.push('/login'); 
      },
    onidle() {
        this.$router.push('/hey-phil');
    },
    onremind(time) {
      // alert seconds remaining to 00:00
      alert(time);
    }
  }
}
</script>

<style scoped>
.btn-home {
  color: white !important;
}

.icons-img {
  width: 15% !important;
  margin-bottom: 5px !important;
  margin-top: 5px !important;
}
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
